import { Link } from 'react-router-dom';
import { formatGBP, formatGBPfromPence, calculateOrderTotalPence, formatDateShort } from '../../lib/format';
import ProgressBar from './ProgressBar';

const statusStyle = {
  LIVE: 'bg-[color:var(--pd-accent-yellow)] text-[#14251c]',
  COMING_SOON: 'bg-[color:var(--pd-gold)] text-[#14251c]',
  SOLD_OUT: 'bg-[color:var(--pd-accent-orange)] text-[#14251c]',
  WINNER_ANNOUNCED: 'bg-[color:var(--pd-gold)] text-[#14251c]',
  CANCELLED: 'bg-[color:var(--pd-danger)] text-white',
};

const statusLabel = {
  LIVE: 'Live',
  COMING_SOON: 'Coming soon',
  SOLD_OUT: 'Sold out',
  WINNER_ANNOUNCED: 'Winner announced',
  CANCELLED: 'Cancelled',
};

export const CompetitionCard = ({ comp }) => {
  const status = comp.status || 'LIVE';
  return (
    <Link
      to={`/competitions/${comp.slug}`}
      className="group block bg-surface border border-pd rounded-2xl overflow-hidden card-lift"
      data-testid="competition-card"
    >
      <div className="relative aspect-[16/10] bg-[color:var(--pd-bg)] overflow-hidden">
        <img
          src={comp.hero_image_url}
          alt={comp.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 heritage-image"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--pd-bg)]/85 via-transparent to-transparent" />
        <span className={`absolute top-3 left-3 font-mono text-[10px] tracking-widest uppercase px-2 py-1 rounded ${statusStyle[status] || statusStyle.LIVE}`}>
          {statusLabel[status] || status}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center justify-between mb-2">
          <div className="font-mono text-[10px] text-muted-sage uppercase">{comp.category}</div>
          <div className="font-mono text-[10px] text-muted-sage">Draw {formatDateShort(comp.draw_date)}</div>
        </div>
        <h3 className="font-display text-2xl leading-none" data-testid="competition-card-title">{comp.title}</h3>
        <p className="text-sm text-muted-sage mt-2 line-clamp-2">{comp.subtitle}</p>
        {status === 'LIVE' && (
          <div className="mt-4">
            <ProgressBar sold={comp.tickets_sold || 0} total={comp.total_tickets} />
          </div>
        )}
        <div className="mt-4 flex items-baseline justify-between">
          <div>
            <div className="font-display text-xl text-[color:var(--pd-accent-yellow)]">{formatGBP(comp.ticket_price_gbp)}<span className="text-xs text-muted-sage font-mono ml-1">/ 1st ticket</span></div>
            <div className="text-[11px] text-muted-sage font-mono mt-0.5" data-testid="card-pair-price">2 for {formatGBPfromPence(calculateOrderTotalPence(comp.ticket_price_gbp, 2))}</div>
          </div>
          <span className="font-mono text-xs text-muted-sage group-hover:text-[color:var(--pd-accent-yellow)]">
            {status === 'COMING_SOON' ? 'Preview →' : 'Enter →'}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CompetitionCard;
